//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['event'],
  mounted() {},
  methods: {}
  // && $date().isBefore($date(event.starts_at))
}
